import { JSX } from 'react'

import { SelectInput } from '~/components/component-library'
import { PaymentSourcePlaceholder } from '~/components/forms/transfer/fields/PaymentSource/PaymentSourcePlaceholder'
import { PaymentSourceTooltip } from '~/components/forms/transfer/fields/PaymentSource/PaymentSourceTooltip'
import {
  usePaymentSourceOptions,
  type PaymentSourceProps,
} from '~/components/forms/transfer/fields/PaymentSource/usePaymentSourceOptions'
import { ErrorFooter } from '~/components/inputs/ErrorFooter'
import { useChainLabel } from '~/utils/chainLabels'

export const PaymentSourceSelect = (props: PaymentSourceProps): JSX.Element => {
  const { options, selectedValue, selectValue, hasNoSelectableSource } =
    usePaymentSourceOptions(props)

  const destinationChainLabel = useChainLabel(props.destinationToken.chainId)

  const error = hasNoSelectableSource
    ? `You don't have enough of a single token${
        props.preventBridge ? ` on ${destinationChainLabel}` : ''
      } to send`
    : props.error

  const footer = error ? <ErrorFooter message={error} /> : undefined

  return (
    <SelectInput<string>
      label="Payment source"
      placeholder={<PaymentSourcePlaceholder />}
      tooltip={<PaymentSourceTooltip />}
      options={options}
      selectedOption={selectedValue}
      // Reserve a trailing checkmark slot on each option so the spend on the
      // right of every row lines up with the trigger (which has the chevron).
      selectedIndicator
      selectValue={selectValue}
      footer={footer}
    />
  )
}
